import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, ListGroup, ListGroupItem, Row, Col, Table, Button, Modal } from 'react-bootstrap';
import { fetchReservationById } from '../../../actions/request/ReservationRequest';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import { MdDownload } from 'react-icons/md';
import { calculateDuration, formatDateView } from '../../../utils/functionData/dateFunction';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { logoApplication } from '../../../utils/dataApi/dataFormApi';
import { FaCreditCard, FaMoneyBillWave, FaUniversity } from 'react-icons/fa';
import { fetchExchangeRateGetCurency } from '../../../actions/request/ExchangeRateRequest';
import { getAndCheckLocalStorage } from '../../../utils/storage/localvalueFuction';
import { localStorageData } from '../../../utils/storage/localvalue';

const ReservationInvoicePage = () => {
    const reservationParam = useParams();
    const dispatch = useDispatch();
    const reservation = useSelector((state) => state.reservations.reservation);
    const invoiceRef = useRef(); // Ref to target the section to export

    const [idReservation, setidReservation] = useState();

    useEffect(() => {
        setidReservation(reservationParam?.id)
        dispatch(fetchReservationById(reservationParam?.id || idReservation));
    }, [dispatch, reservationParam?.id]);

    const [showModalPdfConfirm, setshowModalPdfConfirm] = useState(false);

    const [euroToDinar, setEuroToDinar] = useState(0);


    useEffect(() => {
        setEuroToDinar(getAndCheckLocalStorage(localStorageData.ExchangeRateGetNow) || 0)
        async function getExchangeRate() {
            const { buyRate } = await fetchExchangeRateGetCurency("EUR");
            setEuroToDinar(buyRate);
        }
        getExchangeRate();
    }, [reservation])

    // Taux de conversion fictifs
    const conversionRates = {
        DinarToEuro: 1 / euroToDinar, // Calculé comme 0.00391
        DinarToDollar: 1 / 244, // Exemple : si 1 Dollar = 300 Dinars
    };

    // Fonction pour convertir les montants
    const convertCurrency = (amount, rate) => (amount * rate).toFixed(2);




    if (!reservation) {
        return <p>Aucune Facture trouvée sur cette reservation.</p>;
    }

    const {
        vehicle,
        property,
        client,
        firstname, lastname, email, codePostal, phone,
        startDate,
        endDate,
        totalPrice,
        deliveryFee,
        discount,
        commissionPercentage,
        numberOfGuests,
        specialRequests,
        userAdd

    } = reservation;


    const calculeDiscount = () => {
        const remiseDiscount = Number(Number(totalPrice || 0) - Number(discount || 0))
        return remiseDiscount
    }

    // Calcul des jours de location
    const start = new Date(startDate);
    const end = new Date(endDate);
    const numberOfDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));



    const duration = calculateDuration(startDate, endDate);
    const commissionAmount = (deliveryFee * (commissionPercentage / 100)).toFixed(2);

    const getPaymentMethodLabel = (paymentMethod) => {
        switch (paymentMethod) {
            case "cash":
                return "Espèces";
            case "bank":
                return "Virement bancaire";
            case "card":
                return "Carte de crédit";
            default:
                return "Non spécifié";
        }
    };


    const handleDownloadPDF = () => {
        // Générer le contenu HTML de la facture 
        // const  locationfacture =  "https://res.cloudinary.com/dt6ammifo/image/upload/v1745310296/LOGO_Rezaplus_taoe9z.png"
        const content = `
        <div style="font-family: Arial, sans-serif; margin: 20px;">
            <!-- En-tête -->
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <h4>Facture de Réservation</h4>
                <img src="${logoApplication}" alt="Logo Rezaplus" style="height: 50px; width:50px;" />
            </div>

            <!-- Informations générales -->
            <div style="margin-top: 20px;">
                <p><strong>Numéro de Facture :</strong> ${reservation?.ordre || ""}</p>
                <p><strong>Date de la Facture :</strong> ${formatDateView(Date.now())}</p>
            </div>

            <!-- Sections gauche et droite -->
            <div style="display: flex; justify-content: space-between; margin-top: 20px;">
                <div style="width: 48%; background-color: #f9f9f9; padding: 10px; border-radius: 5px;">
                    <h5 style="color: green;">Facturé par</h5>
                    <p><strong>${userAdd?.companyName || 'Agence de réservation'}</strong></p>
                    <p></p>
                    ${userAdd.companyAddress ? `<p>Addresse : ${userAdd.companyAddress || ''}</p>` : ""}
                    ${userAdd.phone ? `<p>Téléphone : ${userAdd.codePostal.indicatif || ""} ${userAdd.phone || ''}</p>` : ""}
                </div>
                <div style="width: 48%; background-color: #f9f9f9; padding: 10px; border-radius: 5px;">
                    <h5 style="color: green;">Client</h5>
                    <p><strong>${firstname || ''} ${lastname || ''}</strong></p>
                    <p>${email || ''}</p>
                    <p>+${codePostal.indicatif || ''} ${phone || ''}</p>
                </div>
            </div>

            <!-- Détails du véhicule/propriété -->
            <div style="margin-top: 20px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid black;">
                    <thead>
                        <tr>
                            <th style="background-color: green; color: white; padding: 10px;">DÉTAILS ET DESCRIPTION</th>
                            <th style="background-color: green; color: white; padding: 10px;">TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="padding: 10px;">${vehicle?.brand || property?.name || ''} 
                            ${vehicle && vehicle?.brand ?
                `<div>
                            Marque  : ${vehicle?.vehiclebrand || ""}<br />
                            Model : ${vehicle?.model || ""}<br />
                              Couleur : ${vehicle?.color || ""} <br />
                              
                             </div>`: ""
            }

                            ${property && property?.address ?
                `<div>
                            Address : ${property?.address || ""}<br />
                             </div>`: ""
            }
                            
                            </td>
                            <td style="text-align: right; padding: 10px;">${Number(vehicle?.basePricePerDay * numberOfDays || property?.basePricePerDay * numberOfDays || 0).toFixed(0)} DZD</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Moyen de paiement -->
            <div style="display: flex;flex-direction: row; justify-content:space-between;">
            ${reservation && reservation.userAdd && reservation.paymentMethod ?
                `
            <div style="margin-top: 20px;">
                <h5 style="color: green;">Moyen de Paiement</h5>
                ${reservation.paymentMethod === "cash" ?`<p><strong></strong> Espèces </strong> </p>`:""}
                ${reservation.paymentMethod === "bank" ?`<p><strong> Virement bancaire </strong> </p>`:""}
                ${reservation.paymentMethod === "card" ?`<p><strong> Carte de crédit </strong> </p>`:""}

                ${
                  reservation.paymentMethod === "bank" && reservation.userAdd && reservation.userAdd?.bankInfos[0] && reservation.userAdd?.bankInfos[0]?.bankAccountNumber?
                  `<div>
                    <p>Numéro de Compte Agence : ${reservation.userAdd?.bankInfos[0]?.bankAccountNumber || ''}</p>
                    <p>Banque de l'Agence : ${reservation.userAdd?.bankInfos[0]?.bankName || ''}</p>
                    <p>IBAN de l'Agence : ${reservation.userAdd?.bankInfos[0]?.iban || ''}</p>
                    <p>Code SWIFT / BIC de l'Agence : ${reservation.userAdd?.bankInfos[0]?.swiftCode || ''}</p>
                   </div>
                   `:""
                 }
                
            </div>`
                : ""
            }
            

            <!-- Total -->
            <div style="margin-top: 20px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid black;">
                    <tbody>
                        <tr>
                            <td style="padding: 10px;">Prix</td>
                            <td style="text-align: right; padding: 10px;">${Number(vehicle?.basePricePerDay * numberOfDays || property?.basePricePerDay * numberOfDays || 0).toFixed(0)} DZD</td>
                        </tr>
                        ${reservation && reservation.deliveryFee && Number(reservation.deliveryFee) > 0 ?
                `<tr>
                            <td style="padding: 10px;">${vehicle ? "Frais de livraison" : "Frais supplémentaire"}</td>
                            <td style="text-align: right; padding: 10px;">${reservation && reservation.deliveryFee && reservation.deliveryFee ? reservation.deliveryFee : 0} DZD</td>
                        </tr>
                        `: ""
            }
                        <tr>
                            <td style="padding: 10px;"><strong>Total</strong></td>
                            <td style="text-align: right; padding: 10px; border-top: 2px solid black;">${Number(totalPrice || 0).toFixed(0)} DZD = ${convertCurrency(Number(totalPrice || 0), conversionRates.DinarToEuro)} € </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>

            <!-- Conditions de paiement 
            <div style="margin-top: 20px;">
                <h5 style="color: green;">Termes et conditions</h5>
                <p>Veuillez payer dans les 15 jours à compter de la date de facture, tout retard au-delà de 14 jours entraînera des frais de paiement additionnels.</p>
                <p>Veuillez citer le numéro de facture lors du virement bancaire.</p>
            </div>
            -->

            <!-- Pied de page -->
            <div style="margin-top: auto; text-align: start; ">
                <img src="${logoApplication}" alt="Logo Rezaplus" style="height: 50px;" />
                <a href="https://www.rezaplus.com" style="color:green;"> https://www.rezaplus.com</a>
            </div>
        </div>
    `;

        // Créer un élément temporaire pour contenir le contenu HTML
        const element = document.createElement("div");
        element.innerHTML = content;

        // Configurer html2pdf.js
        const opt = {
            margin: 10,
            filename: `Facture_Reservation_${reservation.ordre || ''}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };

        // Générer le PDF
        html2pdf().set(opt).from(element).save();
        handleClosePdfConfirm();
    };

    // Fonction pour afficher/masquer la modale de confirmation
    const handleShowPdfConfirm = () => {
        setshowModalPdfConfirm(true);
    };

    const handleClosePdfConfirm = () => {
        setshowModalPdfConfirm(false);
    };


    return (
        <div className="">
            <Card ref={invoiceRef}>
                <Card.Header>
                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
                        <div><h3>Facture de réservation {reservation?.ordre || ""}</h3></div>
                        <div>
                            <Button id="downloadButton" onClick={handleShowPdfConfirm} variant="primary" size='sm'>
                                <MdDownload />
                                <span className="text-sm"> Télécharger </span>
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body >
                    <Row>
                        {
                            vehicle && (
                                <Col md={6}>
                                    <h4>Détails du véhicule</h4>
                                    <ListGroup>
                                        <ListGroupItem><strong>Nom / designation:</strong> {vehicle?.brand || ""}</ListGroupItem>
                                        <ListGroupItem><strong>Marque:</strong> {vehicle?.vehiclebrand || ""}</ListGroupItem>
                                        <ListGroupItem><strong>Modèle:</strong> {vehicle?.model || ""}</ListGroupItem>
                                        <ListGroupItem><strong>Coleur:</strong> {vehicle?.color || ""}</ListGroupItem>
                                    </ListGroup>
                                </Col>
                            )
                        }

                        {
                            property &&
                            (
                                <Col md={6}>
                                    <h4>Détails de la propriété</h4>
                                    <ListGroup>
                                        <ListGroupItem><strong>Nom/Designation :</strong> {property?.name || ""}</ListGroupItem>
                                        <ListGroupItem><strong>Addresse : </strong> {property?.address || ""}</ListGroupItem>
                                        <ListGroupItem><strong>Année:</strong> {property?.yearBuilt || ""}</ListGroupItem>
                                    </ListGroup>
                                </Col>
                            )
                        }


                        <Col md={6}>
                            <h4>Détails du client</h4>
                            <ListGroup>
                                <ListGroupItem><strong>Nom:</strong> {firstname ? firstname : ""} {lastname ? lastname : ""}</ListGroupItem>
                                <ListGroupItem><strong>Email:</strong> {email ? email : ""}</ListGroupItem>
                                <ListGroupItem><strong>Téléphone:</strong> +{codePostal?.indicatif || ""} {phone ? phone : ""}</ListGroupItem>
                                {
                                    reservation?.companyAirport && reservation?.companyAirport?.name &&
                                    <ListGroupItem>
                                        <strong>Compagnie aérienne :</strong>
                                        <span>{reservation?.companyAirport?.name || ""}</span>
                                    </ListGroupItem>
                                }
                                {
                                    reservation?.numberVolAiport &&
                                    <ListGroupItem>
                                        <strong>N° de Vol :</strong>
                                        <span>{reservation?.numberVolAiport}</span>
                                    </ListGroupItem>
                                }
                            </ListGroup>
                        </Col>
                    </Row>

                    <hr />

                    <Row>
                        <Col>
                            <h4>Détails de la réservation</h4>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>Date de début</th>
                                        <th>Date de fin</th>
                                        <th>Nombre de jours</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{formatDateView(start || "")} - {moment(startDate).format("HH:mm") || ""}</td>
                                        <td>{formatDateView(end || "")} - {moment(endDate).format("HH:mm") || ""}</td>
                                        <td>{duration?.days || ""} jour{duration.days > 1 ? 's' : ''}
                                            {/*, {duration.hours} heure{duration.hours > 1 ? 's' : ''}, {duration.minutes} minute{duration.minutes > 1 ? 's' : ''} */}
                                        </td>
                                    </tr>
                                </tbody>

                                {

                                }
                            </Table>

                            {/*<h5>Demande spéciale :</h5>
                            <p>{specialRequests || "Aucune demande spéciale."}</p> */}
                        </Col>
                    </Row>

                    <hr />

                    <Row>
                        <Col>
                            <h4>Détails du paiement</h4>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>Informations</th>
                                        <th>Montant (DZD)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        reservation && reservation.paymentMethod ?
                                            <tr>
                                                <td>Moyen de paiement </td>
                                                <td> <span className=""> <span className={`ms-2 status`}>
                                                    {' '}
                                                    {/* Adds left margin between label and status */}
                                                    {reservation.paymentMethod === "cash" && (<div className="d-flex flex flex-row"><FaMoneyBillWave size={24} /> <span> Espèces </span> </div>)}
                                                    {reservation.paymentMethod === "bank" && (<div className="d-flex flex flex-row"><FaUniversity size={24} /> <span> Virement bancaire </span> </div>)}
                                                    {reservation.paymentMethod === "card" && (<div className="d-flex flex flex-row"><FaCreditCard size={24} /> <span> Carte de crédit </span> </div>)}
                                                </span></span> </td>
                                            </tr> :
                                            ""
                                    }
                                    {
                                        reservation && reservation.paymentMethod == "bank" ?
                                            <tr>
                                                <td>Information du paiement </td>
                                                <td> <span className=""> <span className={`ms-2 `}>
                                                    {' '}
                                                    {/* Adds left margin between label and status */}
                                                    {
                                                        reservation?.userAdd?.bankInfos.map((item) => {
                                                            return (<div className="py-2 border-bottom">
                                                                {item?.bankAccountNumber && (<div className="d-flex flex flex-row">Numero de compte : <span> {item?.bankAccountNumber || ""} </span> </div>)}
                                                                {item?.bankName && (<div className="d-flex flex flex-row">Banque : <span> {item?.bankName || ""} </span> </div>)}
                                                                {item?.iban && (<div className="d-flex flex flex-row">IBAN : <span> {item?.iban || ""} </span> </div>)}
                                                                {item?.swiftCode && (<div className="d-flex flex flex-row">code swift : <span> {item?.swiftCode || ""} </span> </div>)}
                                                            </div>
                                                            )
                                                        })
                                                    }
                                                </span></span> </td>
                                            </tr> :
                                            ""
                                    }
                                    {
                                        vehicle && (
                                            <tr>
                                                <td>Prix ({vehicle?.basePricePerDay} / jour)</td>
                                                <td>{(vehicle?.basePricePerDay * numberOfDays).toFixed(0)} </td>
                                            </tr>
                                        )
                                    }
                                    {
                                        property && (
                                            <tr>
                                                <td>Prix ( {property?.basePricePerDay}/Jour ) </td>
                                                <td>{(property?.basePricePerDay * numberOfDays).toFixed(0)} </td>
                                            </tr>
                                        )
                                    }

                                    {
                                        reservation && reservation.deliveryFee && Number(reservation.deliveryFee) > 0 ?
                                            <tr>
                                                <td>{vehicle ? "Frais de livraison" : "Frais supplémentaires"}</td>
                                                <td>{reservation && reservation.deliveryFee ? reservation.deliveryFee : "0"} </td>
                                            </tr>
                                            : ""
                                    }



                                    {
                                        commissionAmount && commissionAmount != 0 && (
                                            <tr>
                                                <td>Accompte </td>
                                                <td>{Number(commissionAmount).toFixed(0) || 0} </td>
                                            </tr>
                                        )
                                    }
                                    {
                                        reservation && reservation.paymentCard && reservation.paymentCard && reservation?.paymentCard.card && reservation?.paymentCard.card.amount !== 0
                                            ?
                                            <tr>
                                                <td>Accompte de réservation </td>
                                                <td> <span className="text-danger"> - {Number(reservation?.paymentCard.card.amountReal * 0.1)}  </span> </td>
                                            </tr> :
                                            ""
                                    }
                                    {
                                        reservation && reservation.discount && reservation.discount !== 0 ?
                                            <tr>
                                                <td>Remise </td>
                                                <td>{Number(reservation.discount).toFixed(0)} DZD = {convertCurrency(Number(reservation.discount || 0), conversionRates.DinarToEuro)} € </td>
                                            </tr> :
                                            ""
                                    }

                                    <tr>
                                        <td><strong>Total </strong></td>
                                        <td><strong style={{ fontWeight: "bold" }}>{Number(totalPrice || 0).toFixed(0)} DZD =  {convertCurrency(Number(totalPrice || 0), conversionRates.DinarToEuro)} € </strong></td>
                                    </tr>

                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>


            <Modal show={showModalPdfConfirm} onHide={handleClosePdfConfirm} centered >
                <Modal.Header>Confirmer téléchargement</Modal.Header>
                <Modal.Body>
                    <p>Voulez télécharger la facture de la réservation</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='light' size='sm' onClick={handleClosePdfConfirm}> Annuler </Button>
                    <Button variant='primary' size='sm' onClick={handleDownloadPDF}><MdDownload /> <span>Télécharger</span> </Button>
                </Modal.Footer>

            </Modal>


        </div>
    );
};

export default ReservationInvoicePage;
